import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Boxes, FileText, Briefcase, Inbox } from "lucide-react";
import { api } from "@/lib/oraya-api";

function Stat({ icon: Icon, label, value, to }) {
  return (
    <Link to={to} className="bg-oraya-graphite border border-white/[0.06] rounded-xl p-6 hover:border-white/15 transition-colors" data-testid={`stat-${label.toLowerCase()}`}>
      <Icon className="w-5 h-5 text-oraya-slate" />
      <div className="display text-4xl font-light text-oraya-mist mt-6">{value}</div>
      <div className="text-sm text-oraya-slate mt-1">{label}</div>
    </Link>
  );
}

export default function AdminDashboard() {
  const [counts, setCounts] = useState({ products: "—", insights: "—", careers: "—", enquiries: "—", newEnq: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/admin/products"), api.get("/admin/insights"),
      api.get("/admin/careers"), api.get("/admin/contact-submissions"),
    ]).then(([p, i, c, e]) => {
      setCounts({
        products: p.data.length, insights: i.data.length, careers: c.data.length,
        enquiries: e.data.length, newEnq: e.data.filter((x) => x.status === "New").length,
      });
    }).catch(() => {});
  }, []);

  return (
    <div>
      <h1 className="display text-3xl font-light text-oraya-mist">Overview</h1>
      <p className="text-oraya-slate mt-2">Manage ORAYA systems, insights, careers and enquiries.</p>
      {counts.newEnq > 0 && (
        <div className="mt-6 bg-oraya-accent/10 border border-oraya-accent/30 rounded-xl px-5 py-4 text-sm text-oraya-mist" data-testid="new-enquiry-banner">
          You have <b>{counts.newEnq}</b> new {counts.newEnq === 1 ? "enquiry" : "enquiries"} to review.
        </div>
      )}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        <Stat icon={Boxes} label="Systems" value={counts.products} to="/admin/dashboard/products" />
        <Stat icon={FileText} label="Insights" value={counts.insights} to="/admin/dashboard/insights" />
        <Stat icon={Briefcase} label="Careers" value={counts.careers} to="/admin/dashboard/careers" />
        <Stat icon={Inbox} label="Enquiries" value={counts.enquiries} to="/admin/dashboard/enquiries" />
      </div>
    </div>
  );
}
